const Header = () => {
  return (
    <div className="background-image">
      <div className="wrapper d-flex flex-column align-items-center justify-content-center text-align-center text-white">
        <h1 className="display-2">Meet Our Team</h1>
        <h5 className="py-4 w-50 fw-light text-center">
          
        </h5>
      </div>
    </div>
  );
};

export default Header;
